export default __webpack_public_path__ + "img/Google satellite-89ba2554533ce800c542896356b6268b.jpg";